/* eslint-disable one-var-declaration-per-line,one-var,no-useless-return */
import IMask from 'imask';
import {Toast} from 'bootstrap';
import pathCreator from '../formbuilder/path-creator';
import {htmlTemplates} from './html-templates';
import ConnectExterrnal from './connect-external'
import FormValidatorIndicator from "./formvalidator-indicator";
import FormValidatorUploader from "./file-uploader-validation";
import Loader from "../formbuilder/loader";
/*
*   FormValidator class used to validate forms on frontend
*   HOW TO USE FORM VALIDATION:
*   - add validation class to form base (here: 'cvf_validation')
*   - add desired classes to elements (eg. 'cvf_not-empty cvf_min-3 cvf_only-letters')
*   - the form is now validated
*
* */
const connectExternal = new ConnectExterrnal();
const formvalidatorIndicator = new FormValidatorIndicator();
const formvalidatorUploader = new FormValidatorUploader();
const loader = new Loader();

const regexes = {
    email: new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@ąęłćśńóżźĄĘŁŚĆŚŃÓŻŹ"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@ąęłćśńóżźĄĘŁŚĆŚŃÓŻŹ"]+)*))@((([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$'),
    phone: new RegExp('^\\d{9}$'),
    postalCode: new RegExp('^\\d{2}-\\d{3}$'),
    pesel: new RegExp('^\\d{11}$'),
    regon: new RegExp('^\\d{9}$'),
    onlyLetters: new RegExp('^[a-zA-ZĄąĆćĘęŁłŃńÓóŚśŹźŻż ]{1,}$'), // change to \\p{L}
    onlyNumbers: new RegExp('^\\d{1,}$'),
    decimalNumbers: new RegExp('^\\d+(\\.\\d+|\\,\\d+)?$'),
    currencyNumbers: new RegExp('^\\d+(\\.\\d{2}|\\,\\d{2})?$'),
    nip: new RegExp('^\\d{10}$'),
    ppe: new RegExp('^(5903106)[0-9]{11}$'),
    name: new RegExp('^(\\p{L}+) ([\\p{L} -]+)$', 'u'), // change to fullName
    date: new RegExp('^(\\d{2}-){2}\\d{4}$'), // validate date
    contractorNumber: new RegExp('^\\d{8}$'),
    repeat: new RegExp('.{1,}_repeat'),
    maxLength: (max) => new RegExp(`^.{1,${max}}$`),
};

/*
  INPUT MASKS:
      - '0' - any digit
      - 'a' - any letter
      - '*' - any char
      - '[]' - optional input
      - '{}' - include fixed part

   IMask docs: https://imask.js.org/guide.html
 */

const masks = {
    phoneMask: (input) => IMask(input, {mask: '000 000 000'}),
    nipMask: (input) => IMask(input, {mask: '000-000-00-00'}),
    ppeMask: (input) => IMask(input, {mask: '000000000000000000'}),
    postalCodeMask: (input) => IMask(input, {mask: '00{-}000'}),
    peselMask: (input) => IMask(input, {mask: '00000000000'}),
    regonMask: (input) => IMask(input, {mask: '000000000'}),
    dateMask: (input) => IMask(input, {mask: '00{-}00{-}0000'}),
    contractorNumberMask: (input) => IMask(input, {mask: '00000000'}),
};

export default class FormValidator {
    prefix = 'cvf_';

    state = {
        validationClass: `${this.prefix}validation`,
        notEmptyClass: `${this.prefix}not-empty`,
        emailClass: `${this.prefix}email`,
        phoneClass: `${this.prefix}phone`,
        onlyLettersClass: `${this.prefix}only-letters`,
        onlyNumbersClass: `${this.prefix}only-numbers`,
        decimalNumbersClass: `${this.prefix}decimal`,
        currencyNumbersClass: `${this.prefix}currency`,
        postalCodeClass: `${this.prefix}postal-code`,
        peselClass: `${this.prefix}pesel`,
        isAdultClass: `${this.prefix}adult`,
        regonClass: `${this.prefix}regon`,
        nipClass: `${this.prefix}nip`,
        ppeClass: `${this.prefix}ppe`,
        nameClass: `${this.prefix}name`,
        dateClass: `${this.prefix}date`,
        dateMaxClass: `${this.prefix}date_max`,
        dateMinClass: `${this.prefix}date_min`,
        contractorNumberClass: `${this.prefix}contractor-number`,
        smsAuthorisation: `${this.prefix}sms_code`,
        fileUpload: `${this.prefix}uploaded`,
        eitherClass: `${this.prefix}either`,
        repeatSuffix: '_repeat',
    };

    constructor(form, first) {
        this.form = form;
        this.first = first;
        this.token = this.form.querySelector(`input[name="formRuntimeDataToken"]`);
        this.inputs = form.querySelectorAll('input[type=\'text\'], input[type=\'number\'], input[type=\'email\'], textarea, select, fieldset');// input[type='checkbox']
        this.checkboxes = form.querySelectorAll('input[type=\'checkbox\'],input[type=\'radio\']');
        this.isFormValid = false;
        this.popupShown = false;
        this.blockIndicator = true; // blocks the visual indicator
        this.hasPanels = Boolean(this.form.querySelectorAll('.panel').length > 0);
        if (this.hasPanels) {
            this.panelsSort = form.querySelector(".panelsSort");
            if (this.panelsSort) {
                this.panelsSort = "simple";
            }
        }
        this.init(this.form.classList.contains(`${this.state.validationClass}`));
        this.popupContainer = document.querySelector('.cvf_popup-container');
        if (!this.popupContainer) this.popupContainer = document.createElement('div');

        if (this.hasPanels) {
            this.panelIndex = 0;
            this.activePanel = null;
            this.panels = [];
            this.pathCreator = pathCreator;
            this.panelsSort = this.panelsSort;//simple

            document.addEventListener('panelChanged', (e) => {
                this.panelIndex = e.detail.newPanelIndex;
                this.activePanel = e.detail.panels[e.detail.newPanelIndex];
                var controllers = document.querySelector('.btn-controllers');
                if(controllers)
                {
                    if(e.detail.previousPanelIndex && e.detail.panels[e.detail.previousPanelIndex])
                    {
                        var praviosPanel = e.detail.panels[e.detail.previousPanelIndex];
                        praviosPanel.querySelectorAll("[data-wasdisabled]").forEach(element => {
                            if (!element.disabled) {
                                element.removeAttribute('data-wasdisabled');
                            }
                        })
                    }

                    this.form.querySelectorAll('input, select, textarea, button').forEach(element => {
                        if (element.type === 'button' || element.type === 'submit' || element.type === 'hidden') return;
                    
                        if (!element.hasAttribute('data-wasdisabled')) {
                            element.setAttribute('data-wasdisabled', element.disabled);
                        }
                    
                        if (!this.activePanel.contains(element)) {
                            element.disabled = true;
                        }
                    });


                    this.activePanel.querySelectorAll('input, select, textarea').forEach(element => {
                        const wasDisabled = element.getAttribute('data-wasdisabled') === 'true';
                    
                        if (!wasDisabled) {
                            element.disabled = false;
                        }
                    });


                    this.activePanel.parentElement.insertAdjacentElement("afterend", controllers);
                }
                this.panels = e.detail.panels;
                this.panelsSort = this.panelsSort;//simple
            });
        }

        this.inputs.forEach(el => {
            if (el.type === 'fieldset') {
                el.classList.add('form-type-radio-button');
                let elemChildren = el.children;
                elemChildren.forEach((elm) => {
                    if (elm.tagName === 'DIV') {
                        el = elm;
                    }
                });
            }
            if (el.getAttribute('data-initial-constraints') && el.getAttribute('data-initial-constraints').includes('not_blank')) {
                el.classList.add('cvf_not-empty');
            }

            if (el.getAttribute('data-initial-constraints') && el.getAttribute('data-initial-constraints').includes('email')) {
                el.classList.add('cvf_email');
            }

            if (el.getAttribute('data-initial-constraints') && el.getAttribute('data-initial-constraints').includes('date')) {
                el.classList.add('cvf_date');
            }


            if (el.getAttribute('class') && el.getAttribute('class').search("cvf_not-empty") !== -1) {
                el.correct = false;
            } else {
                el.correct = true;
            }
        });
        if (form.querySelector('.oc_smscode') && this.first) {
            connectExternal.smsCreate(this.form);
        }
    }


    /**
     * Checks if the input is not empty
     * @param {Node} input - validated input element
     */
    checkNotEmpty(input) {
        input.correct = input.correct && input.value.length > 0;

        if ((input.getAttribute('required') === 'required' && input.value === '') ||
            (input.classList.contains("cvf_not-empty") && input.value === '')) {
            input.correct = false;
        }

        if (input.correct !== true) {
            if (input.type === 'select-one') {
                input.parentElement.frontMessages = "Wybierz z listy. ";
            } else if (input.type === 'select-multiple') {
                input.parentElement.frontMessages = "Wybierz z listy wielokrotnego wyboru. ";
            } else {
                input.frontMessages = "Uzupełnij pole. ";
            }
        }

        if (!input.parentElement.parentElement.classList.contains('visible') && input.parentElement.parentElement.classList.contains('hideable-parent')) {
            input.correct = true;
        }

        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input has the desired minimum length
     * @param {Node} input - validated input element
     * @param {Number} min - minimum desired length
     */
    checkMinLength(input, min) {
        input.correct = input.correct && input.value.length >= min;
        if (input.correct !== true) {
            input.frontMessages = `Wpisz conajmniej ${min} znaków.`
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input has the desired maximum length
     * @param {Node} input - validated input element
     * @param {Number} max - maximum desired length
     */
    checkMaxLength(input, max) {
        const mask = IMask(input, {
            mask: regexes.maxLength(max),
        });
        input.correct = input.correct && input.value.length <= max;
        if (input.correct !== true) {
            input.frontMessages = `Wpisz maksymalnie ${max} znaków.`
        }
        input.hasValidationClass = true;
    }

    checkLessThan(input, checkedNumber) {
        const floatValue = input.value.replace(',', '.');

        input.correct = input.correct && floatValue <= parseFloat(checkedNumber);
        if (input.correct !== true) {
            input.frontMessages = `Maksymalna wartość to ${checkedNumber}`
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid e-mail address
     * Checks if there is a repeated e-mail field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkEmail(input) {
        const regex = regexes.email;
        const repeatedInput = this.getRepeatedInput(this.state.emailClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value)
                && (repeatedInput.value !== '' ? input.value === repeatedInput.value : true);
            repeatedInput.correct = input.correct;
            if (repeatedInput.value !== '') formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny format adresu email. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid phone number
     * Checks if there is a repeated phone field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkPhone(input) {
        const mask = masks.phoneMask(input);
        const regex = regexes.phone;
        const repeatedInput = this.getRepeatedInput(this.state.phoneClass);
        if (repeatedInput) {
            // check if repeated input is empty
            // if yes, don't compare
            input.correct = input.correct && regex.test(mask.unmaskedValue) && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(mask.unmaskedValue);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny numer telefonu. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid postal code
     * Checks if there is a repeated postal code field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkPostalCode(input) {
        // masks.postalCodeMask(input);
        const regex = regexes.postalCode;
        /** If copy adress, mask not work this is solutions */
        let value = input.value.replace(/\D/g, '');
        let formattedValue = value
            .replace(/(\d{2})(\d{1,3})/, '$1-$2')
            .slice(0, 6);
        input.value = formattedValue;
        const repeatedInput = this.getRepeatedInput(this.state.postalCodeClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value) && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny kod pocztowy. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid PESEL number
     * Checks if there is a repeated pesel field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkPesel(input) {
        const mask = masks.peselMask(input);

        const peselDigits = mask.unmaskedValue.split('');
        const weights = [1, 3, 7, 9];
        let sum = 0;
        let index = 0;

        peselDigits.forEach((digit, i) => {
            if (i < peselDigits.length - 1) sum += (digit * weights[index++]) % 10;

            if (index > weights.length - 1) index = 0;
        });

        const controlNumber = 10 - (sum % 10);
        let finalControlNumber;

        if (controlNumber == 10) {
            finalControlNumber = 0;
        } else {
            finalControlNumber = controlNumber;
        }

        const regex = regexes.pesel;
        const repeatedInput = this.getRepeatedInput(this.state.peselClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value) && (peselDigits[peselDigits.length - 1] == finalControlNumber)
                && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value) && (peselDigits[peselDigits.length - 1] == finalControlNumber);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny numer PESEL. "
        }
        input.hasValidationClass = true;
    }

    isAdult(input) {
        const mask = masks.peselMask(input);
        const pesel = mask.unmaskedValue;

        const regex = regexes.pesel;

        let year = parseInt(pesel.substring(0, 2));
        let month = parseInt(pesel.substring(2, 4));
        const day = parseInt(pesel.substring(4, 6));

        let birthDate;

        if (month >= 21) {
            month -= 20;
            birthDate = new Date(2000 + year, month - 1, day);
        } else {
            birthDate = new Date(1900 + year, month - 1, day);
        }

        const today = new Date();
        const age = today.getFullYear() - birthDate.getFullYear() - (today < new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate()) ? 1 : 0);

        if (age >= 18) {
            input.correct = input.correct;
        } else {
            input.correct = false;
            input.frontMessages = "PESEL należy do osoby niepełnoletniej";
        }
        input.hasValidationClass = true;

    }

    /**
     * Checks if the validated input is a valid REGON number
     * Checks if there is a repeated regon field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkRegon(input) {
        const mask = masks.regonMask(input);

        const regonDigits = mask.unmaskedValue.split('');
        const weights = [8, 9, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let index = 0;

        regonDigits.forEach((digit, i) => {
            if (i < regonDigits.length - 1) sum += (digit * weights[index++]);

            if (index > weights.length - 1) index = 0;
        });

        const controlNumber = sum % 11;
        const calculatedControlNumber = controlNumber === 10 ? 0 : controlNumber;

        const regex = regexes.regon;
        const repeatedInput = this.getRepeatedInput(this.state.regonClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value) && (regonDigits[regonDigits.length - 1] == calculatedControlNumber)
                && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            this.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value) && (regonDigits[regonDigits.length - 1] == calculatedControlNumber);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny numer REGON. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid NIP number
     * Checks if there is a repeated NIP field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkNip(input) {
        const mask = masks.nipMask(input);

        const nipDigits = mask.unmaskedValue.split('');
        const nipWeights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;

        nipWeights.forEach((weight, index) => {
            sum += nipDigits[index] * weight;
        });

        const controlDigit = sum % 11;
        const regex = regexes.nip;
        const repeatedInput = this.getRepeatedInput(this.state.nipClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(mask.unmaskedValue) && (nipDigits[nipDigits.length - 1] == controlDigit)
                && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(mask.unmaskedValue) && (nipDigits[nipDigits.length - 1] == controlDigit);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny numer NIP. "
        }
        input.hasValidationClass = true;
    }


    /**
     * Checks if the validated input is a valid full name
     * Checks if there is a repeated name field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkName(input) {
        const regex = regexes.name;
        const repeatedInput = this.getRepeatedInput(this.state.nameClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value) && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niewłaściwa wartość. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input is a valid date (format: DD-MM-YYYY)
     * Checks if there is a repeated date field, and if yes then compares the two fields
     * @param {Node} input - validated input element
     */
    checkDate(input) {
        const mask = masks.dateMask(input);

        const regex = regexes.date;
        const repeatedInput = this.getRepeatedInput(this.state.dateClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(mask.unmaskedValue) && input.value === repeatedInput.value;
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(mask.unmaskedValue);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny format daty. "
        }
        input.hasValidationClass = true;
    }

    checkMaxValueDate(input) {
        const max = input.max;
        if (max == 'today') {
            if (input.value > new Date().toISOString().split('T')[0]) {
                input.correct = false;
                input.frontMessages = "Data nie może być późniejsza niż dzisiaj. ";
            }
        }
        else if (max.includes('days')) {
            const days = Math.abs(parseInt(max));
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + days);
            if (new Date(input.value) > maxDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być późniejsza niż ${days} dni od dzisiaj. `;
            }
        }
        else if (max.includes('weeks')) {
            const weeks = Math.abs(parseInt(max));
            const maxDate = new Date();
            maxDate.setDate(maxDate.getDate() + weeks * 7);
            if (new Date(input.value) > maxDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być późniejsza niż ${weeks} tygodni od dzisiaj. `;
            }
        }
        else if (max.includes('months')) {
            const months = Math.abs(parseInt(max));
            const maxDate = new Date();
            maxDate.setMonth(maxDate.getMonth() + months);
            if (new Date(input.value) > maxDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być późniejsza niż ${months} miesięcy od dzisiaj. `;
            }
        }
        else if (max.includes('years')) {
            const years = Math.abs(parseInt(max));
            const maxDate = new Date();
            maxDate.setFullYear(maxDate.getFullYear() + years);
            if (new Date(input.value) > maxDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być późniejsza niż ${years} lat od dzisiaj. `;
            }
        }

        input.hasValidationClass = true;

    }

    checkMinValueDate(input) {
        const min = input.min;
        if (min == 'today') {
            if (input.value < new Date().toISOString().split('T')[0]) {
                input.correct = false;
                input.frontMessages = "Data nie może być wcześniejsza niż dzisiaj. ";
            }
        }
        else if (min.includes('days')) {
            const days = Math.abs(parseInt(min));
            const minDate = new Date();
            minDate.setDate(minDate.getDate() - days);
            if (new Date(input.value) < minDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być wcześniejsza niż ${days} dni od dzisiaj. `;
            }
        }
        else if (min.includes('weeks')) {
            const weeks = Math.abs(parseInt(min));
            const minDate = new Date();
            minDate.setDate(minDate.getDate() - weeks * 7);
            if (new Date(input.value) < minDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być wcześniejsza niż ${weeks} tygodni od dzisiaj. `;
            }
        }
        else if (min.includes('months')) {
            const months = Math.abs(parseInt(min));
            const minDate = new Date();
            minDate.setMonth(minDate.getMonth() - months);
            if (new Date(input.value) < minDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być wcześniejsza niż ${months} miesięcy od dzisiaj. `;
            }
        }
        else if (min.includes('years')) {
            const years = Math.abs(parseInt(min));
            const minDate = new Date();
            minDate.setFullYear(minDate.getFullYear() - years);
            if (new Date(input.value) < minDate) {
                input.correct = false;
                input.frontMessages = `Data nie może być wcześniejsza niż ${years} lat od dzisiaj. `;
            }
        }

        input.hasValidationClass = true;

    }

    /**
     * Checks if the validated input is a valid ENEA contractor number
     * Makes a call to SKOK to check if the number is registered there
     * @param {Node} input - validated input element
     */
    checkContractorNumber(input) {
        const mask = masks.contractorNumberMask(input);

        const regex = regexes.contractorNumber;
        input.correct = false;

        if (!regex.test(input.value)) return;

        fetch(`/api/skok/${input.value}`)
            .then((response) => response.json()
                .then((jsonResponse) => {
                    if ((jsonResponse.isOk === true) && regex.test(input.value)) {
                        fetch(`/api/checklist/${this.form.id}/${input.value}`)
                            .then((res) => res.json())
                            .then((res) => {
                                if (res.countList === 0) {
                                    input.correct = (jsonResponse.isOk === true) && regex.test(input.value);
                                    formvalidatorIndicator.correctIndicator(input);
                                }
                            });
                    }
                    formvalidatorIndicator.correctIndicator(input);
                }));
        if (input.correct !== true) {
            input.frontMessages = "Nie potwierdzono numeru Klienta. "
        }
        input.hasValidationClass = true;
    }

    checkSMSCode(input) {

        if (input.correct !== true) {
            input.frontMessages = "Błędny kod SMS "
        }
        input.hasValidationClass = true;
    }


    /**
     * Checks if the validated input's value consists of letters only
     * @param {Node} input - validated input element
     */
    checkIfOnlyLetters(input) {
        const mask = IMask(input, {
            mask: regexes.onlyLetters,
        });
        const regex = regexes.onlyLetters;
        input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawna wartość pola. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input's value consists of digits only
     * @param {Node} input - validated input element
     */
    checkIfOnlyNumbers(input) {
        const mask = IMask(input, {
            mask: regexes.onlyNumbers,
        });
        const regex = regexes.onlyNumbers;
        input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawna wartość pola. "
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input's value consists of digits or decimals only
     * @param {Node} input - validated input element
     */
    checkIfDecimals(input) {
        const regex = regexes.decimalNumbers;
        input.correct = input.correct && regex.test(input.value);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawna wartość pola."
        }
        input.hasValidationClass = true;
    }

    /**
     * Checks if the validated input's value consists of digits or decimals only
     * @param {Node} input - validated input element
     */
    checkIfCurrency(input) {
        const regex = regexes.currencyNumbers;
        input.correct = input.correct && regex.test(input.value);
        
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawna wartość pola. Podaj dwa miejsca po przecinku."
        }
        input.hasValidationClass = true;
    }

    checkPpe(input) {
        const mask = masks.ppeMask(input);
        const ppeDigits = mask.unmaskedValue.split('');
        const weights = [3,1]
        let sum = 0;

        ppeDigits.forEach((digit, i) => {
            if (i < ppeDigits.length - 1) sum += (digit * weights[i%2])

        });
        const controlNumber = 10 - (sum % 10);
        let finalControlNumber;

        if (controlNumber == 10) {
            finalControlNumber = 0;
        } else {
            finalControlNumber = controlNumber;
        }

        const regex = regexes.ppe;
        const repeatedInput = this.getRepeatedInput(this.state.ppeClass);
        if (repeatedInput) {
            input.correct = input.correct && regex.test(input.value) && input.value === repeatedInput.value && (ppeDigits[ppeDigits.length - 1] == finalControlNumber);
            repeatedInput.correct = input.correct;
            formvalidatorIndicator.correctIndicator(repeatedInput);
        } else input.correct = input.correct && regex.test(input.value) && (ppeDigits[ppeDigits.length - 1] == finalControlNumber);
        if (input.correct !== true) {
            input.frontMessages = "Niepoprawny numer PPE."
        }
        input.hasValidationClass = true;
    }

    checkEither(input) {
        const eithers = this.form.querySelectorAll('.cvf_either');
        let filledField = false;

        eithers.forEach(either => {

            if (either.value !== null && either.value !== '') {

                filledField = true;
                either.correct = true;
                if (either.classList.contains('cvf_ppe')) {
                    this.checkPpe(either)
                }
                formvalidatorIndicator.correctIndicator(either);
            } else {
                if (input.value !== '') {
                    either.correct = true;
                    formvalidatorIndicator.correctIndicator(either);

                }
            }
        });

        input.correct = input.correct && filledField;

        if (input.correct !== true) {
            input.frontMessages = "Podaj prawidłowy numer licznika lub PPE (5903106XXXXXXXXXXX)";


            input.hasValidationClass = true;

        }


    }

    getRepeatedInput(c) {
        return this.form.querySelector(`.${c}_repeat`); // use suffix variable
    }

    /**
     * Checks if all required checkboxes are checked
     */
    checkCheckboxes() {
        let correct = true;
        this.checkboxes.forEach((checkbox) => {
            if (checkbox.getAttribute('required') === 'required' && !checkbox.checked) correct = false;
            checkbox.frontMessages = "Niepoprawna wartość. "
            formvalidatorIndicator.correctIndicator(checkbox);
        });
        if (checkboxes.correct !== true) {
            checkboxes.frontMessages = "Niepoprawna wartość. "
        }
        return correct;
    }

    checkRadioButton(input) {
        let radioButtons = input.getElementsByTagName('input');
        radioButtons.forEach((radio) => {
            if (radio.checked) {
                input.correct = true;
                input.firstChild.correct = true;
                input.lastChild.correct = true;
                formvalidatorIndicator.correctIndicator(input);
            }
        });

    }


    /**
     * Finds the repeated input field and then compares it to the original field
     * @param {Node} input - validated input element
     */
    checkRepeat(input) {
        let className;
        let isRepeatedFieldValidatedByRegex = true;
        const classListArray = input.classList.toString().split(' ');
        classListArray.forEach((el) => {
            const spl = el.split('_');
            if (spl.length > 2 && spl[2] === 'repeat') className = [spl[0], spl[1]].join('_');
        });

        if (!className) return;

        const originalInput = this.form.querySelector(`.${className}`);

        switch (className) {
            case this.state.phoneClass:
                const regexPhone = regexes.phone;
                masks.phoneMask(input);
                input.correct = input.correct && regexPhone.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.nipClass:
                const regexNip = regexes.nip;
                masks.nipMask(input);
                input.correct = input.correct && regexNip.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.ppeClass:
                const regexPpe = regexes.ppe;
                masks.ppeMask(input);
                input.correct = input.correct && regexPpe.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.postalCodeClass:
                const regexPostalCode = regexes.postalCode;
                masks.postalCodeMask(input);
                input.correct = input.correct && regexPostalCode.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.peselClass:
                const regexPesel = regexes.pesel;
                masks.peselMask(input);
                input.correct = input.correct && regexPesel.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.isAdultClass:
                const regexPeselAdult = regexes.pesel;
                masks.peselMask(input);
                input.correct = input.correct && regexPeselAdult.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.regonClass:
                const regexRegon = regexes.regon;
                masks.regonMask(input);
                input.correct = input.correct && regexRegon.test(input.value) && input.value === originalInput.value;
                break;


            case this.state.nameClass:
                const regexName = regexes.name;
                IMask(input, {mask: regexes.name});
                input.correct = input.correct && regexName.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.dateClass:
                const regexDate = regexes.date;
                masks.dateMask(input);
                input.correct = input.correct && regexDate.test(input.value) && input.value === originalInput.value;
                break;

            case this.state.emailClass:
                const regexEmail = regexes.email;
                input.correct = input.correct && regexEmail.test(input.value) && input.value === originalInput.value;
                break;


            default:
                isRepeatedFieldValidatedByRegex = false;
                input.correct = input.correct && input.value === originalInput.value;
                break;
        }
        if (isRepeatedFieldValidatedByRegex) originalInput.correct = input.correct;
        else originalInput.correct = originalInput.correct && input.correct;
        formvalidatorIndicator.correctIndicator(originalInput);
    }

    /**
     * Validates a single checkbox
     * Returns true when a checkbox is checked and required
     *                              is unchecked and unrequired
     *                              is checked and unrequired
     * @param {Node} checkbox - checkbox element
     * Function for checkbox is works
     */
    validateCheckbox(checkbox) {

        if (!checkbox.parentElement.parentElement.parentElement.classList.contains('visible') && checkbox.parentElement.parentElement.parentElement.classList.contains('hideable-parent')) {
            checkbox.correct = true;
            return true;
        }

        checkbox.correct = false;

        if (checkbox.type !== 'radio') {
            if (checkbox.getAttribute('required') === 'required') {
                if (checkbox.checked) {
                    checkbox.correct = true;
                }
                if (checkbox.correct !== true) {
                    checkbox.parentElement.parentElement.frontMessages = "Pole wymagane.";
                }
                formvalidatorIndicator.correctIndicator(checkbox);
                return checkbox.checked;
            } else {
                checkbox.correct = true;
            }
        } else {

            if (checkbox.getAttribute('required') === 'required') {
                const radios = checkbox.parentElement.parentElement.querySelectorAll('input[type="radio"]');
                checkbox.correct = false;
                radios.forEach(radio => {
                    if (radio.checked === true) {
                        checkbox.correct = true;
                    }
                });
            } else {
                checkbox.correct = true;
            }
        }
        if (checkbox.correct !== true) {
            // checkbox.frontMessages = "Pole wymagane. ";
            checkbox.parentElement.parentElement.frontMessages = "Pole wymagane."

            formvalidatorIndicator.correctIndicator(checkbox);
            return false;
        }

        formvalidatorIndicator.correctIndicator(checkbox);

        return true;
    }

    /**
     * Validates a single (active) panel based only on its inputs
     * @param {Number} panelIndex - active panel index
     * @param {Node} button - control button element (previous / next)
     */
    validatePartial(panelIndex, button) {
        if (button.parentNode.classList.contains('panel-button-previous')) return;

        let panel = this.activePanel;

        const panelInputs = panel.querySelectorAll('input[type=\'text\'], input[type=\'number\'], input[type=\'email\'], textarea, select, fieldset');
        const panelCheckboxes = panel.querySelectorAll('input[type=\'checkbox\'],input[type=\'radio\']');

        panelInputs.forEach(input => {
            this.checkIfOptional(input);

        });

        let isPanelCorrect = [...panelInputs].every((input) => input.correct === true);

        isPanelCorrect = isPanelCorrect && [...panelCheckboxes].every((checkbox) => this.validateCheckbox(checkbox));

        isPanelCorrect = isPanelCorrect && this.checkFileUpload(panel)

        isPanelCorrect = isPanelCorrect && this.checkPanelEither(panel)
        ///console.log(isPanelCorrect + " " + this.checkPanelEither(panel))
        if (!panel) {
            panel = document;
        }
        if (!isPanelCorrect) {
            panel.classList.add('incorrect');
            panelInputs.forEach(input => {
                    this.checkValidationType(input);
                }
            )

            panelCheckboxes.forEach(input => {
                this.validateCheckbox(input);
            });

            // this.showPopup(this.popupContainer, false, panelInputs);
            this.checkFileUpload(panel)

            //this.checkPanelEither(panelInputs);
            return;
        }

        if (panel.classList.contains('incorrect')) panel.classList.remove('incorrect');
    }

    checkPanelEither(panel) {
        const eithers = panel.querySelectorAll('.cvf_either');
        let isPanelCorrect = false;

        if (eithers.length > 0) {
            let filledField = false;

            eithers.forEach(either => {


                if ((either.value !== null && either.value !== '') || (either.parentElement.classList.contains('hideable-parent') && !either.parentElement.classList.contains('visible'))) {
                    isPanelCorrect = true;
                    /* if  (either.value !== null && either.value !== '')  console.log("nie puste");
                      if(either.parentElement.classList.contains('hideable-parent')) console.log("hideable-parent");*/
                }
            });
            if (!isPanelCorrect) {
                eithers.forEach(either => {
                    either.correct = false;
                    formvalidatorIndicator.correctIndicator(either);

                })
            }

        } else {
            isPanelCorrect = true
        }
        return isPanelCorrect;
    }

    checkFileUpload(panel) {
        let isPanelCorrect = true;
        let fileUploadsHtml = '';
        let fileUploads = panel.querySelector('.dz-sum-error');//just one per document
        if (fileUploads) {
            if (fileUploads.innerHTML !== '') {
                isPanelCorrect = false;
                fileUploadsHtml = fileUploads.innerHTML;

            }
            let filesCount = 0;

            let uploadedConstraints = panel.querySelector('div[classFormGroup="cvf_uploaded"]');
            if (uploadedConstraints) {
                if (uploadedConstraints.hasAttribute('data-initial-constraints')) {
                    let uploadedConstraintsValue = uploadedConstraints.getAttribute('data-initial-constraints');

                    if (uploadedConstraintsValue === 'dynamic_multi_file_not_blank') {

                        let filesCount = panel.querySelectorAll('.dz-file-preview').length;
                        //    console.log(`Załadowano ${filesCount}`);
                        if (filesCount === 0) {
                            isPanelCorrect = false;
                            panel.querySelector('.dz-sum-error').innerHTML = "Załącz wymagane dokumenty"
                        }

                    }
                }
            }

        }
        return isPanelCorrect;
    }

    /**
     * Checks if the field is optional (not required and empty)
     * @param {Node} input - validated input element
     */
    checkIfOptional(input) {

        if (input.getAttribute('required') === 'required' && input.value === '') {
            input.correct = false;
            return;
        }
        if (input.classList.contains("cvf_not-empty") && input.value === '') {
            input.correct = false;
            return;
        }

        if (input.classList.contains("cvf_either") || input.classList.contains("cvf_sms_code")) {
            return;
        }

        if (input.value !== '') {
            return;
        }

        input.correct = true;
    }

    /**
     * Initializes the validator
     * Adds event listeners to input fields
     * @param {Boolean} isValidated - boolean value representing if the form is validated
     */
    init(isValidated) {
        if (!isValidated) return;

        window.addEventListener('DOMContentLoaded', () => {
            // change to 'submit' event on form
            this.form.querySelector("button[type='submit']").addEventListener('click', (e) => {
                this.handleSubmit(e);

            });

            if (this.hasPanels) {
                const controlButtons = document.querySelectorAll('.panel-button-next button, .panel-button-previous button');

                controlButtons.forEach((button) => {
                    button.addEventListener('click', () => {
                        this.validatePartial(this.panelIndex, button);
                    });
                });
            }


            this.checkboxes.forEach((input) => {
                input.addEventListener('click', () => {
                    this.validateCheckbox(input);
                });

            });

            this.inputs.forEach((input) => {
                input.hasValidationClass = false;


                if (input.nodeName === 'SELECT') {
                    if (input.value !== '') input.correct = true;
                    input.addEventListener('click', () => {
                        const selectOpens = input.getAttribute('opens');
                        const shownInput = this.form.querySelector(`input[openname='${selectOpens}']`);
                        if (shownInput) {
                            shownInput.correct = false;
                            this.checkIfOptional(shownInput);
                        }
                    });
                }

                input.addEventListener('input', () => {
                    this.checkValidationType(input);
                });

            });
            this.blockIndicator = false;
        });
        /** remove loader before redirecting */
        window.addEventListener('beforeunload', function (event) {
            loader.removeLoader();
        });
    }

    /**
     * Checks the validation type of the given field
     * Checks if the field is optional
     * Indicates if the field is filled correctly
     * @param {Node} input - validated input element
     */
    checkValidationType(input) {
        input.correct = true;

        if (input.classList.contains(this.state.notEmptyClass)) this.checkNotEmpty(input);

        let minLength, maxLength, checkedNumber;

        input.classList.forEach((item) => {
            if (item.match(/cvf_min-[0-9]{1,}/)) minLength = item.split('-')[1];
            if (item.match(/cvf_max-[0-9]{1,}/)) maxLength = item.split('-')[1];
            if (item.match(/cvf_less-[0-9]{1,}/)) checkedNumber = item.split('-')[1];
        });
        if (minLength) this.checkMinLength(input, minLength);
        if (maxLength) this.checkMaxLength(input, maxLength);
        if (checkedNumber) this.checkLessThan(input, checkedNumber);

        if (input.type == "fieldset") {
            input.correct = false;
            this.checkRadioButton(input);
        }

        if (input.classList.contains(this.state.emailClass)) this.checkEmail(input);
        if (input.classList.contains(this.state.phoneClass)) {
            this.checkPhone(input);
        }
        if (input.classList.contains(this.state.onlyNumbersClass)) this.checkIfOnlyNumbers(input);
        if (input.classList.contains(this.state.decimalNumbersClass)) this.checkIfDecimals(input);
        if (input.classList.contains(this.state.currencyNumbersClass)) this.checkIfCurrency(input);
        if (input.classList.contains(this.state.onlyLettersClass)) this.checkIfOnlyLetters(input);
        if (input.classList.contains(this.state.postalCodeClass)) this.checkPostalCode(input);
        if (input.classList.contains(this.state.peselClass)) this.checkPesel(input);
        if (input.classList.contains(this.state.isAdultClass)) this.isAdult(input);
        if (input.classList.contains(this.state.regonClass)) this.checkRegon(input);
        if (input.classList.contains(this.state.nipClass)) this.checkNip(input);
        if (input.classList.contains(this.state.ppeClass)) this.checkPpe(input);
        if (input.classList.contains(this.state.nameClass)) this.checkName(input);
        if (input.classList.contains(this.state.dateClass)) this.checkDate(input);
        if (input.classList.contains(this.state.eitherClass)) this.checkEither(input);
        if (input.classList.contains(this.state.contractorNumberClass)) this.checkContractorNumber(input);
        if (input.max !== '' && input.classList.contains(this.state.dateClass)) this.checkMaxValueDate(input);
        if (input.min !== '' && input.classList.contains(this.state.dateClass)) this.checkMinValueDate(input);

        if (input.classList.contains(this.state.smsAuthorisation)) {
            let promise= connectExternal.sendCheckSMS(this.form, input);
            input.correct = input.classList.contains('validSms') ? true : false;
        }
        if (input.classList.toString().match(regexes.repeat)) this.checkRepeat(input);


        this.checkIfOptional(input);
        this.removeHiddenFields();
        formvalidatorIndicator.correctIndicator(input);
    }

    /**
     * Shows a success or failure popup
     * @param {Element} container - popup container element
     * @param {Boolean} isCorrect - boolean value representing if the form is filled correctly
     * @param {Node} inputs - inputs that are currently validated
     */
    showPopup(container, isCorrect, inputs, textSuccess = '') {
        container.classList.add('cvf_popup-container');
        textSuccess = (textSuccess == 'Success!') ? null : textSuccess;
        const {popupSuccessTemplate, popupFailTemplate, popupNoCheckboxesTemplate} = htmlTemplates(textSuccess, this.form.dataset.popupredirect);
        container.innerHTML = isCorrect ? popupSuccessTemplate : popupFailTemplate;
        if (!this.form.querySelector('.popup-container')) this.form.appendChild(container);

        if (!isCorrect) {
            const paragraph = container.querySelector('.cvf_incorrect-fields');
            inputs.forEach((input) => {
                formvalidatorIndicator.correctIndicator(input);
                if (input.type === 'fieldset') {
                    let elemChildren = input.children;
                    elemChildren.forEach((elm) => {
                        if (elm.tagName === 'DIV') {
                            input = elm;
                        }
                    });
                }
                if (input.type === 'checkbox' && !this.validateCheckbox(input)) {
                    let parent = input.parentElement;
                    let labelContent;
                    let elementLabel;

                    if (parent.classList.contains('my-checkbox-long')) {
                        parent = parent.parentElement;
                        // labelContent = parent.querySelector('.checkbox_radio_label').querySelector('span').innerText;
                    }
                    // } else labelContent = parent.querySelector('.checkbox_radio_label').innerText;
                    elementLabel = parent.querySelector('.checkbox_radio_label');
                    labelContent = elementLabel.innerText;
                    if (labelContent === '' || labelContent === null) {
                        if (elementLabel.nextElementSibling !== null) {
                            labelContent = elementLabel.nextElementSibling.innerText;
                        }
                    }

                    const maxLabelLength = 50;
                    if (labelContent.length > maxLabelLength) {
                        labelContent = labelContent.slice(0, maxLabelLength);
                        const arr = [...labelContent];
                        arr.splice(maxLabelLength - 3, 3, '.', '.', '.');
                        labelContent = arr.join('');
                    }

                    paragraph.innerHTML += `${labelContent}<br>`;
                } else if (input.correct === false) {
                    if (input.nextElementSibling === null && input.previousElementSibling === null) {
                        input = input.parentElement;
                    }
                    if (input.nextElementSibling != null) {
                        if (input.nextElementSibling.nodeName === 'LABEL' || input.nextElementSibling.nodeName === 'LEGEND') {
                            paragraph.innerHTML += `${input.nextElementSibling.innerText}<br>`;
                        }
                    }
                    if (input.previousElementSibling != null) {
                        if (input.previousElementSibling.nodeName === 'LABEL' || input.previousElementSibling.nodeName === 'LEGEND') {
                            paragraph.innerHTML += `${input.previousElementSibling.innerText}<br>`;
                        }
                    }
                }
            });
        }


        let idForm = "form[name=" + this.form.name + "]";
        let popupToast = ' #cvf_popup-toast';
        const toast = new Toast(document.querySelector(idForm + popupToast), {
            autohide: false,
        });
        if (isCorrect) {
            toast.show();
        }

    }

    /**
     * Handles submission of the form
     * Builds the popup container and calls the correct showPopup method
     * @param {Event} event - submit event
     */
    handleSubmit(event) {

        if (this.hasPanels) this.removeHiddenPanels();

        let thisElement = this;

        this.inputs.forEach(input => {

                this.checkValidationType(input);
            }
        )

        this.checkboxes.forEach(input => {
            this.validateCheckbox(input);
        });
        this.checkIfFormIsValid();
        this.removeHiddenFields();


        let isValid = this.isFormValid;
        let isUploadValid = this.checkFileUpload(document)


        if (!isValid || !isUploadValid) {
            isValid = false;
        }

        if (!isValid) {
            /** This event blocked send form if isFormValid not true */
            event.preventDefault();
        } else {
            this.restorePanelFieldsBeforeSubmit();
            if (this.form.querySelector('button[type="submit"]') && this.form.querySelector('button[type="submit"]').classList.contains('loader-div')) {
                loader.addLoader(this.form);
            }
        }

        let observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.addedNodes.length) {
                    let classListElement = mutation.addedNodes[0].classList;
                    let textElement = mutation.addedNodes[0].textContent;
                    classListElement.forEach((cls) => {
                        if (cls === 'alert-success' && isValid) {
                            thisElement.showPopup(thisElement.popupContainer, true, thisElement.inputs, textElement);
                            loader.removeLoader();
                            return;
                        }
                        if (cls === 'alert-danger') {
                            loader.removeLoader();
                            if (mutation.addedNodes[0].textContent.includes('Manipulated runtime token detected')) {

                                mutation.addedNodes[0].textContent = mutation.addedNodes[0].textContent.replace('Manipulated runtime token detected', 'token uległ zmianie');
                            }
                        }
                    });
                }
            })
        })
        let alert = this.form.querySelector('.div-alert .col-12');
        if (alert) {
            observer.observe(alert, {
                childList: true
            });
        }
        // this.showPopup(this.popupContainer, false, this.inputs);
    }

    /**
     * Re-enables fields from inactive panels before submit.
     * Disabled fields are not serialized by the browser, so values from previous steps
     * would be lost without this step.
     */
    restorePanelFieldsBeforeSubmit() {
        if (!this.hasPanels || !this.activePanel) return;

        this.form.querySelectorAll('input, select, textarea').forEach((element) => {
            if (this.activePanel.contains(element)) return;

            if (element.getAttribute('data-wasdisabled') === 'false') {
                element.disabled = false;
            }
        });
    }

    /**
     * Removes panels skipped by the path from validation
     */
    removeHiddenPanels() {
        if (this.panels.length < 1) return;
        if (!this.pathCreator.getPath()) return;

        this.panels.forEach((panel, index) => {
            if (this.pathCreator.getPath().includes((index + 1).toString())) return;

            panel.querySelectorAll('input[type=\'text\'], input[type=\'number\'], input[type=\'email\'], textarea, select').forEach((input) => {
                input.correct = true;
            });
        });
    }

    /**
     * Removes fields with 'display: none' from validator
     * This method is used when a field appears based on a choice in a select field
     */
    removeHiddenFields() {
        this.inputs.forEach((input) => {
            if (input instanceof Element && input.parentNode instanceof Element) {
                const inputDisplayStyle = window.getComputedStyle(input).display;
                const parentDisplayStyle = window.getComputedStyle(input.parentNode).display;

                if (inputDisplayStyle === 'none' || parentDisplayStyle === 'none') {
                    input.correct = true;
                }
            }
        });

        this.checkboxes.forEach((input) => {
            if (input instanceof Element && input.parentNode instanceof Element) {
                const inputDisplayStyle = window.getComputedStyle(input).display;
                const parentDisplayStyle = window.getComputedStyle(input.parentNode).display;

                if (inputDisplayStyle === 'none' || parentDisplayStyle === 'none') {
                    input.correct = true;
                }
            }
        });
    }


    checkIfFormIsValid() {
        /*const foundIncorrect = Array.from(this.inputs).find((input) => input.correct === false || input.correct == null);
        this.isFormValid = (foundIncorrect === undefined);*/
        this.isFormValid = true;

        this.inputs.forEach((input) => {
            if (input.correct === false || input.correct == null) {

                this.isFormValid = false;
            }
        });

        this.checkboxes.forEach((input) => {
            if (input.correct === false || input.correct == null) {
                this.isFormValid = false;
            }
        });

    }

    createLoader() {

        if (document.querySelector('form button[type="submit"]') && document.querySelector('form button[type="submit"]').classList.contains('loader-div')) {
            let form = document.querySelector('form');

            let createDiv = document.createElement('div');
            createDiv.classList.add('col-12', 'd-flex', 'justify-content-center')

            let loaderDiv = document.createElement('div');
            loaderDiv.className = 'loader';
            createDiv.appendChild(loaderDiv);

            form.addEventListener('submit', function (event) {
                if (this.isFormValid) {
                    form.appendChild(createDiv);
                }
                window.scrollBy(0, 100);
            });

            /** remove loader before redirecting */
            window.addEventListener('beforeunload', function (event) {
                createDiv.remove();
            });

            /** remove loader if show alert */
            let observer = new MutationObserver(function (mutations) {
                mutations.forEach(function (mutation) {
                    if (mutation.addedNodes.length) {
                        let classListElement = mutation.addedNodes[0].classList;
                        classListElement.forEach((cls) => {
                            if (cls === 'alert-success' || cls === 'alert-danger') {
                                createDiv.remove();
                            }
                        });
                    }
                })
            })
            let alert = form.querySelector('.div-alert .col-12');
            if (alert) {
                observer.observe(alert, {
                    childList: true
                });
            }

        }

    }
}